import React from "react";
import "./index.css";

const DrawerList = (props) => {
  const { isSample, listItems } = props;
  if (isSample) {
    return (
      <ul style={{ padding: "0 40px" }}>
        <li>List Item 1</li>
        <li>List Item 2</li>
        <li>List Item 3</li>
        <li>List Item 4</li>
        <li>List Item 5</li>
      </ul>
    );
  }

  return (
    <ul className="drawer-list" style={{ padding: "0 40px" }}>
      {listItems?.map((item, itemIndex) => {
        return (
          <li className="drawer-list-item" key={`list${itemIndex}`}>
            {item}
          </li>
        );
      })}
    </ul>
  );
};

export default DrawerList;
